import { IKhoa } from "../../model/respone/category/IKhoa";
import { apiClient } from "../apiClient";
export const KHOA_API = "khoa";
export const khoaApi = {
  SelectAll: () => apiClient.get(`${KHOA_API}`),
  Insert: (payload: IKhoa) => apiClient.post(`${KHOA_API}`, payload),
  Update: (payload: IKhoa) => apiClient.put(`${KHOA_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${KHOA_API}/${id}`),
};
